module.exports = __webpack_public_path__ + "static/media/diag01.51eccf15.jpg";